var _style, _defs, _g, _g2, _defs2, _g3, _g4, _g5, _defs3, _g6, _g7;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRightCam(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 182.2 170",
    style: {
      enableBackground: "new 0 0 182.2 170"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{clip-path:url(#SVGID_00000022558611234274575090000011970633662015248790_);}\r\n\t.st1{fill:#525660;}\r\n\t.st2{fill:#95B4CF;}\r\n\t.st3{clip-path:url(#SVGID_00000096038667577131382560000016808890511914822817_);}\r\n\t.st4{fill:#FFFFFF;}\r\n\t.st5{opacity:0.5;fill:#525660;}\r\n\t.st6{fill:none;}\r\n\t.st7{fill-rule:evenodd;clip-rule:evenodd;fill:#6A6A65;}\r\n\t.st8{clip-path:url(#SVGID_00000090992850648315735580000010170491109382257539_);}\r\n\t.st9{fill-rule:evenodd;clip-rule:evenodd;fill:#735F5D;}\r\n\t.st10{clip-path:url(#SVGID_00000028304762154128137900000017972306242018148235_);}\r\n\t.st11{display:none;}\r\n\t.st12{display:inline;}\r\n\t.st13{clip-path:url(#SVGID_00000009592301762640556380000013735192103497245597_);}\r\n\t.st14{clip-path:url(#SVGID_00000153668532714322819240000003866720144387740304_);}\r\n")), /*#__PURE__*/React.createElement("g", {
    id: "Capa_1_copia"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000126308856883698160490000009693969730236695485_",
    x: 130.8,
    y: 48,
    width: 49,
    height: 49
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000044177074248725913300000017700487004970937004_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000126308856883698160490000009693969730236695485_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Video_camera_front_00000169542226397867354600000004785133169843989384_",
    style: {
      clipPath: "url(#SVGID_00000044177074248725913300000017700487004970937004_)"
    }
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_00000031197435015241485010000003866246666699839920_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_00000111172562930720011640000007751088925730143384_",
    className: "st1",
    d: "M136.7,63c-0.6-0.7-1.7-0.2-1.7,0.7 v17.6c0,0.9,1.1,1.4,1.7,0.7l6.4-6.4v9.2c0,2.2,1.8,4.1,4.1,4.1h24.5c2.2,0,4.1-1.8,4.1-4.1V60.2c0-2.2-1.8-4.1-4.1-4.1h-24.5 c-2.2,0-4.1,1.8-4.1,4.1v9.2L136.7,63z M163.5,68.4c0,2.2-1.8,4.1-4.1,4.1s-4.1-1.8-4.1-4.1c0-2.2,1.8-4.1,4.1-4.1 S163.5,66.1,163.5,68.4z M151.3,79.5c0-1.7,1-3.1,2.5-3.8c1.7-0.8,3.7-1.2,5.7-1.2s3.9,0.4,5.7,1.2c1.5,0.7,2.5,2.1,2.5,3.8 v1.2h-16.3V79.5z"
  }))))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M19.7,62.4h35.4V122L19,140.8c-0.6-0.1-1-0.6-1-1.1V64.1C18.1,63.2,18.8,62.4,19.7,62.4z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M127.4,82.8l4.1-2.1V138c0,2.7-2.2,4.9-4.9,4.9H90.3v-41.2l4-2.1l0,4.5v34.7h32.3c0.5,0,0.9-0.4,0.9-0.9 V87.3"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M57.3,123.2v15.7h33v-32.6l0.5-3.8l3.6-2.9V143H53.2v-22.3l3.9-2L57.3,123.2z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M19.5,138.9h33.6v-13.6l0.3-4.2l3.7-2.4V143H19.7c-1.2,0-2.2-0.6-2.5-1.6c-0.1-0.4-0.4-1.7,1.1-2.7l1.8-9.1 "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "55.3,122 55.3,141 55.1,141 55.1,122  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "53.1,143 57.3,143 57.3,118.6 53.1,120.8  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M53.2,125.3V60.4h41.1v43.9l-4-2.5V64.5h-33v54.2L53.2,125.3z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M20.1,142.4l-1.4,0.4c-1.6-0.3-2.7-1.6-2.7-3.1V64.1c0-2,1.6-3.7,3.7-3.7h37.4v62.9l-4,2.1l0-4.6V64.5h-33 V138V142.4z"
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "Capa_1_copia_2"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs2 || (_defs2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000090991673526710665360000001406422758636682132_",
    x: 130.8,
    y: 48,
    width: 49,
    height: 49
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000154386328171521044060000002153492538632954752_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000090991673526710665360000001406422758636682132_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Video_camera_front_00000016038134615335305000000003081873800221566654_",
    style: {
      clipPath: "url(#SVGID_00000154386328171521044060000002153492538632954752_)"
    }
  }, _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Group_00000155127917279345237950000000868464956377454979_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_00000072981570411173137840000014247280474605458352_",
    className: "st1",
    d: "M136.7,63c-0.6-0.7-1.7-0.2-1.7,0.7 v17.6c0,0.9,1.1,1.4,1.7,0.7l6.4-6.4v9.2c0,2.2,1.8,4.1,4.1,4.1h24.5c2.2,0,4.1-1.8,4.1-4.1V60.2c0-2.2-1.8-4.1-4.1-4.1h-24.5 c-2.2,0-4.1,1.8-4.1,4.1v9.2L136.7,63z M163.5,68.4c0,2.2-1.8,4.1-4.1,4.1s-4.1-1.8-4.1-4.1c0-2.2,1.8-4.1,4.1-4.1 S163.5,66.1,163.5,68.4z M151.3,79.5c0-1.7,1-3.1,2.5-3.8c1.7-0.8,3.7-1.2,5.7-1.2s3.9,0.4,5.7,1.2c1.5,0.7,2.5,2.1,2.5,3.8 v1.2h-16.3V79.5z"
  }))))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M94.3,104.3v34.7h32.3c0.5,0,0.9-0.4,0.9-0.9V87.3v-4.5l4-2.1V138c0,2.7-2.2,4.9-4.9,4.9H90.3v-41.2l4-2.1"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "55.3,122 55.3,141 55.1,141 55.1,122  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "53.1,143 57.3,143 57.3,118.6 53.1,120.8  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M92.3,62.4H128c0.8,0,1.5,0.7,1.5,1.5V84l-37.2,19V62.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M94.3,104.3l-4,2.1V60.4H128c2,0,3.6,1.6,3.6,3.6v26.3l-4,2.1l0-9.5V64.5H94.3v35.3V104.3z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polyline", {
    className: "st2",
    points: "57.3,120.9 55.3,123 55.3,63.4 92.3,63.4 93,102.1 89.7,104.3  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M57.3,123.2l-4,2.1V60.4h41.1v49.3v4.5l-4-6.8v-43h-33v44.2"
  }))))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M6.5,64.5v74.6c0,1.7,1.3,3,3,3h0c1.7,0,3-1.3,3-3l0-74.6c0-1.7-1.3-3-3-3h0C7.9,61.5,6.5,62.9,6.5,64.5z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: -1,
    y: 64.5,
    className: "st6",
    width: 15,
    height: 14
  })), /*#__PURE__*/React.createElement("rect", {
    x: 5.6,
    y: 74.9,
    className: "st9",
    width: 1.5,
    height: 2.6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 5.6,
    y: 70.2,
    className: "st9",
    width: 1.5,
    height: 2.6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 5.6,
    y: 65.6,
    className: "st9",
    width: 1.5,
    height: 2.6
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: -1,
    y: 78.5,
    className: "st6",
    width: 15,
    height: 14
  })), /*#__PURE__*/React.createElement("rect", {
    x: 5.6,
    y: 88.9,
    className: "st9",
    width: 1.5,
    height: 2.6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 5.6,
    y: 84.2,
    className: "st9",
    width: 1.5,
    height: 2.6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 5.6,
    y: 79.6,
    className: "st9",
    width: 1.5,
    height: 2.6
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: -1,
    y: 92.5,
    className: "st6",
    width: 15,
    height: 14
  })), /*#__PURE__*/React.createElement("rect", {
    x: 5.6,
    y: 102.9,
    className: "st9",
    width: 1.5,
    height: 2.6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 5.6,
    y: 98.2,
    className: "st9",
    width: 1.5,
    height: 2.6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 5.6,
    y: 93.6,
    className: "st9",
    width: 1.5,
    height: 2.6
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: -1,
    y: 106.5,
    className: "st6",
    width: 15,
    height: 14
  })), /*#__PURE__*/React.createElement("rect", {
    x: 5.6,
    y: 116.9,
    className: "st9",
    width: 1.5,
    height: 2.6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 5.6,
    y: 112.2,
    className: "st9",
    width: 1.5,
    height: 2.6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 5.6,
    y: 107.6,
    className: "st9",
    width: 1.5,
    height: 2.6
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: -1,
    y: 120.5,
    className: "st6",
    width: 15,
    height: 14
  })), /*#__PURE__*/React.createElement("rect", {
    x: 5.6,
    y: 130.9,
    className: "st9",
    width: 1.5,
    height: 2.6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 5.6,
    y: 126.2,
    className: "st9",
    width: 1.5,
    height: 2.6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 5.6,
    y: 121.6,
    className: "st9",
    width: 1.5,
    height: 2.6
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M-1,134.5v3.5v0.9l0,0.3c0,0.3,0,0.5,0,0.8c0,0.5,0.1,1,0.2,1.5c0.5,2,1.5,3.9,3,5.3 c1.5,1.4,3.4,2.4,5.4,2.7c2,0.4,4.1,0.1,6-0.7c1.9-0.8,3.5-2.2,4.6-3.9c1.1-1.7,1.7-3.8,1.7-5.8H5c0-0.9,0.3-1.8,0.7-2.5 c0.5-0.7,1.2-1.3,2-1.7c0.8-0.4,1.7-0.4,2.6-0.3c0.9,0.2,1.7,0.6,2.3,1.2c0.6,0.6,1.1,1.4,1.3,2.3c0,0.2,0.1,0.4,0.1,0.6 c0,0.1,0,0.2,0,0.3l0-0.2V138v-3.5H-1z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M10.4,141.4l0.5,1.4c1.1-0.4,2-1.3,2.3-2.4l-1.4-0.5C11.6,140.6,11.1,141.1,10.4,141.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M7.2,140l-1.4,0.6c0.4,1.1,1.3,1.9,2.4,2.3l0.5-1.4C8.1,141.2,7.5,140.6,7.2,140z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 5.6,
    y: 135.6,
    className: "st9",
    width: 1.5,
    height: 2.6
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 5,
    y: 125.1,
    className: "st6",
    width: 15,
    height: 14
  })), /*#__PURE__*/React.createElement("rect", {
    x: 12,
    y: 126.1,
    className: "st9",
    width: 1.5,
    height: 2.6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 12,
    y: 130.8,
    className: "st9",
    width: 1.5,
    height: 2.6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 12,
    y: 135.4,
    className: "st9",
    width: 1.5,
    height: 2.6
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 5,
    y: 111.1,
    className: "st6",
    width: 15,
    height: 14
  })), /*#__PURE__*/React.createElement("rect", {
    x: 12,
    y: 112.1,
    className: "st9",
    width: 1.5,
    height: 2.6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 12,
    y: 116.8,
    className: "st9",
    width: 1.5,
    height: 2.6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 12,
    y: 121.4,
    className: "st9",
    width: 1.5,
    height: 2.6
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 5,
    y: 97.1,
    className: "st6",
    width: 15,
    height: 14
  })), /*#__PURE__*/React.createElement("rect", {
    x: 12,
    y: 98.1,
    className: "st9",
    width: 1.5,
    height: 2.6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 12,
    y: 102.8,
    className: "st9",
    width: 1.5,
    height: 2.6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 12,
    y: 107.4,
    className: "st9",
    width: 1.5,
    height: 2.6
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 5,
    y: 83.1,
    className: "st6",
    width: 15,
    height: 14
  })), /*#__PURE__*/React.createElement("rect", {
    x: 12,
    y: 84.1,
    className: "st9",
    width: 1.5,
    height: 2.6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 12,
    y: 88.8,
    className: "st9",
    width: 1.5,
    height: 2.6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 12,
    y: 93.4,
    className: "st9",
    width: 1.5,
    height: 2.6
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 5,
    y: 69.1,
    className: "st6",
    width: 15,
    height: 14
  })), /*#__PURE__*/React.createElement("rect", {
    x: 12,
    y: 70.1,
    className: "st9",
    width: 1.5,
    height: 2.6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 12,
    y: 74.8,
    className: "st9",
    width: 1.5,
    height: 2.6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 12,
    y: 79.4,
    className: "st9",
    width: 1.5,
    height: 2.6
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M20,69.1v-3.5v-0.9l0-0.3c0-0.3,0-0.5,0-0.8c0-0.5-0.1-1-0.2-1.5c-0.5-2-1.5-3.9-3-5.3 c-1.5-1.4-3.4-2.4-5.4-2.7c-2-0.4-4.1-0.1-6,0.7c-1.9,0.8-3.5,2.2-4.6,3.9C-0.4,60.4-1,62.5-1,64.5h15c0,0.9-0.3,1.8-0.7,2.5 c-0.5,0.7-1.2,1.3-2,1.7c-0.8,0.4-1.7,0.4-2.6,0.3c-0.9-0.2-1.7-0.6-2.3-1.2c-0.6-0.6-1.1-1.4-1.3-2.3c0-0.2-0.1-0.4-0.1-0.6 c0-0.1,0-0.2,0-0.3l0,0.2v0.9v3.5H20z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M8.7,62.2l-0.5-1.4c-1.1,0.4-2,1.3-2.3,2.4l1.4,0.5C7.4,63,8,62.5,8.7,62.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M11.8,63.6l1.4-0.6c-0.4-1.1-1.3-1.9-2.4-2.3l-0.5,1.4C11,62.4,11.6,62.9,11.8,63.6z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 12,
    y: 65.4,
    className: "st9",
    width: 1.5,
    height: 2.6
  })))))))), /*#__PURE__*/React.createElement("g", {
    id: "Capa_1",
    className: "st11"
  }, /*#__PURE__*/React.createElement("g", {
    className: "st12"
  }, /*#__PURE__*/React.createElement("g", null, _defs3 || (_defs3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000019635719216455661370000003135273174190186406_",
    x: 131.1,
    y: 47,
    width: 49,
    height: 49
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000160159552137816400630000011983431360476797061_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000019635719216455661370000003135273174190186406_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Video_camera_front_00000098183495726303754570000011251271254665362606_",
    style: {
      clipPath: "url(#SVGID_00000160159552137816400630000011983431360476797061_)"
    }
  }, _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    id: "Group_00000034799442943368748720000016551628013099546241_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_00000103972652231217348370000007774308417993773737_",
    className: "st1",
    d: "M136.9,62.1c-0.6-0.7-1.7-0.2-1.7,0.7 v17.6c0,0.9,1.1,1.4,1.7,0.7l6.4-6.4v9.2c0,2.2,1.8,4.1,4.1,4.1H172c2.2,0,4.1-1.8,4.1-4.1V59.3c0-2.2-1.8-4.1-4.1-4.1h-24.5 c-2.2,0-4.1,1.8-4.1,4.1v9.2L136.9,62.1z M163.8,67.5c0,2.2-1.8,4.1-4.1,4.1s-4.1-1.8-4.1-4.1s1.8-4.1,4.1-4.1 S163.8,65.2,163.8,67.5z M151.5,78.6c0-1.7,1-3.1,2.5-3.8c1.7-0.8,3.7-1.2,5.7-1.2s3.9,0.4,5.7,1.2c1.5,0.7,2.5,2.1,2.5,3.8 v1.2h-16.3V78.6z"
  }))))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M90.5,100.9l41.3-21.1v57.3c0,2.7-2.2,4.9-4.9,4.9H90.5V100.9z M94.6,103.4V138h32.3c0.5,0,0.9-0.4,0.9-0.9 V86.4L94.6,103.4z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M53.5,119.8l41.1-21v43.3H53.5V119.8z M90.5,105.4l-33,16.8V138h33V105.4z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M17.4,140.4c-0.1-0.4-0.4-1.7,1.1-2.7l38.9-19.9v24.2H20C18.7,142.1,17.8,141.4,17.4,140.4z M53.3,124.4 L26.7,138h26.6V124.4z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "55.5,121 55.5,140 55.4,140 55.4,121.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "53.3,142.1 57.6,142.1 57.6,117.7 53.3,119.9  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M92.6,61.5h35.7c0.8,0,1.5,0.7,1.5,1.5v20.1l-37.2,19V61.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M90.5,59.5h37.7c2,0,3.6,1.6,3.6,3.6v21.3l-41.3,21.1V59.5z M127.8,63.5H94.6v35.3l33.2-16.9V63.5z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "55.5,121 55.5,61.5 92.6,61.5 92.6,102.1  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M53.5,59.5h41.1v43.9l-41.1,21V59.5z M90.5,63.5h-33v54.2l33-16.8V63.5z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M20,61.5h35.4v59.6l-36.1,18.7c-0.6-0.1-1-0.6-1-1.1V63.1C18.3,62.2,19.1,61.5,20,61.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M19,141.9c-1.6-0.3-2.7-1.6-2.7-3.1V63.1c0-2,1.6-3.7,3.7-3.7h37.4v62.9L19.6,142L19,141.9z M53.3,63.5h-33 V137l33-17.1V63.5z"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRightCam);
export default __webpack_public_path__ + "static/media/RightCam.ebcec08a9460d2694c8c323d210974b7.svg";
export { ForwardRef as ReactComponent };